<script>
import { logout } from '../services/api/authentication'
export default {
  created() {
    this.$router.replace({ name: 'dashboard' }).then(() => {
      logout()
    })
  }
}
</script>